import { Heading } from '@big-red-group/storefront-common-ui'
import { ListItem } from './NZRiskDisclosureStatement.styles'
import Modal from '@/components/Modal'
import Container from '@/components/Container'
import { Spacing } from '@big-red-group/storefront-common-ui'

type NZRiskDisclosureProps = {
  isOpen: boolean
  onClose: () => void
}

const NZRiskDisclosure = ({ isOpen, onClose }: NZRiskDisclosureProps) => {
  return (
    <>
      <Modal
        height="750px"
        width="960px"
        isOpen={isOpen}
        onClose={onClose}
        title="Risk Disclosure Statement"
        showCloseIcon
      >
        <Container>
          <Heading size="S">UNDERSTANDING THE RISKS OF ADVENTURE TOURISM EXPERIENCES</Heading>
          <p>
            I accept that this activity inherently involves risks and potential hazards. The risks and hazards included
            in adventure experiences, but are not limited to are:
          </p>
          <ul>
            <ListItem>
              Skydiving: Risks include equipment failure, adverse weather conditions, and the possibility of hard
              landings.
            </ListItem>
            <ListItem>
              Jet Boating: Potential hazards include high-speed manoeuvres leading to collisions or passengers being
              thrown from the boat, and the risk of hitting submerged objects.
            </ListItem>
            <ListItem>
              Skiing and Snowboarding: Hazards include avalanches, collisions with other skiers or objects, and the risk
              of falls or injuries due to uneven terrain.
            </ListItem>
            <ListItem>
              White Water Rafting: Risks involve capsizing, falling out of the raft, collisions with rocks or other
              obstacles in the river, and rapid currents.
            </ListItem>
            <ListItem>
              Bungy Jumping: Main risks include equipment malfunction, improper harness attachment, and the physical
              strain of the sudden stop at the end of the jump.
            </ListItem>
            <ListItem>
              Hiking and Guided Walks: Potential hazards include adverse weather conditions, getting lost, wildlife
              encounters, and injuries from falls or uneven terrain.
            </ListItem>
            <ListItem>
              Canyoning: Risks include slipping and falling on wet rocks, flash flooding, and injuries from jumps or
              rappels.
            </ListItem>
            <ListItem>
              Mountain Biking: Hazards include falls, collisions with other bikers or obstacles, and mechanical failures
              of the bike.
            </ListItem>
            <ListItem>
              Quad Biking: Risks involve overturning the vehicle, collisions with obstacles or other riders, and
              potential mechanical failures.
            </ListItem>
            <ListItem>
              Paragliding and Hang Gliding: Main hazards include equipment failure, adverse weather conditions, and the
              risk of hard landings.
            </ListItem>
            <ListItem>
              Jet boat: Risks include the high-speed manoeuvres and potential for collisions or falls from the boat.
            </ListItem>
            <ListItem>
              Sea Kayaking: Potential hazards include changing weather conditions, capsizing, and the physical demands
              of paddling, especially in rough waters.
            </ListItem>
            <ListItem>
              Helicopter Flights: Risks involve adverse weather conditions, mechanical failures, and potential hard
              landings.
            </ListItem>
          </ul>
          <Spacing />
          <p>
            I am aware that participating in adventure activities offered by the adventure experience operator can be
            hazardous if they are not conducted with care, control and responsibility. I acknowledge that these risks
            could result in my injury (physical or mental) or even death.
          </p>
        </Container>
      </Modal>
    </>
  )
}

export default NZRiskDisclosure
